module.exports = __webpack_public_path__ + "img/VC.966e2bb6.svg";